export const DEFAULT_MARKET_ID = 1;
export const DEFAULT_MARKET_MAP_SETTINGS_AREA = [
  [-98.0099140659006, 30.103350447665438],
  [-97.60479321629123, 30.03322980117988],
  [-97.44137158543185, 30.634755801217477],
  [-97.88769116550998, 30.698542502401953],
];
